import ReactGA from 'react-ga';
import config from './config';

export const initGA = () => {
  ReactGA.initialize(config.gaTrackingId);
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
};

export const logEvent = (category, action, label) => {
  ReactGA.event({ category, action, label });
};

export const logException = (description, fatal = false) => {
  ReactGA.exception({ description, fatal });
};
